(function () {
  var bar = document.querySelector('.product-action-bar');
  if (!bar) return;

  var btns = bar.querySelectorAll('.lang-btn');

  // On page load, restore language preference from localStorage
  document.addEventListener('DOMContentLoaded', function () {
    var savedLang = localStorage.getItem('adarna-lang');
    if (savedLang === 'fil') {
      document.documentElement.dataset.lang = 'fil';
      btns.forEach(function (btn) {
        if (btn.dataset.lang === 'fil') {
          btn.classList.add('active');
          btn.setAttribute('aria-pressed', 'true');
        } else {
          btn.classList.remove('active');
          btn.setAttribute('aria-pressed', 'false');
        }
      });
    }
  });

  // On language button click, update global data-lang and persist
  btns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var lang = btn.dataset.lang;
      document.documentElement.dataset.lang = lang;
      localStorage.setItem('adarna-lang', lang);

      // Update active state
      btns.forEach(function (b) {
        b.classList.remove('active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('active');
      btn.setAttribute('aria-pressed', 'true');
    });
  });
})();
